module.exports = __webpack_public_path__ + "img/heart_hand.c0238005.png";